__webpack_require__.p = "/learn/interactive/why-should-you-use-eye-protection/";